import { Color } from '@genial/design-tokens';

export const stylesPdf = (lineColor: string) => {
  return `
<style>
  @font-face {
    font-family: 'SourceSansPro-Bold';
    font-display: swap;
    src: local('SourceSansPro-Bold'), url('./../fonts/SourceSansPro-Bold.ttf') format('truetype');
  }

  @font-face {
    font-family: 'SourceSansPro-Regular';
    font-display: swap;
    src: local('SourceSansPro-Regular'), url('./../fonts/SourceSansPro-Regular.ttf') format('truetype');
  }

  * {
    font-family: 'SourceSansPro-Regular';
    box-sizing: border-box;
  }

  .container {
    padding: 30px;
    position: relative;
    width: 690px;
  }

  .flex-container {
    display: flex;
  }

  .space-between {
    justify-content: space-between;
  }

  .align-center {
    align-items: center;
  }

  .flex-column {
    flex-direction: column;
  }

  .font-size-lg {
    font-size: 18px;
  }

  .font-size-md {
    font-size: 14px;
  }

  .font-size-sm {
    font-size: 11px;
  }

  .line-height-lg {
    line-height: 24px;
  }

  .line-height-md {
    line-height: 18px;
  }

  .line-height-sm {
    line-height: 16.5px;
  }

  .font-weight-bold {
    font-weight: 500;
  }

  .font-weight-regular {
    font-weight: 400;
  }

  .color-title {
    color: ${Color['brand.tertiary.dark']};
  }

  .radius-default {
    border-radius: 8px;
  }

  .line-box {
    padding: 16px 0px;
    border-top: 1px solid ${Color['brand.primary.lightest']};
    border-bottom: 1px solid ${Color['brand.primary.lightest']}
  }

  .section-box {
    padding: 8px 16px;
    background: rgba(232, 234, 250, 0.2);
    gap: 4px;
  }

  .neutral-medium-color {
    color: ${Color['neutral.medium']};
  }

  .order-label {
    width: 30%;
    color: ${Color['neutral.medium']};
  }

  .order-text {
    color: ${Color['neutral.black']};
  }

  .full-width {
    width: 100%;
  }

  .flex-row {
    flex-direction: row;
  }

  .details-tab {
    margin: 0px auto;
    justify-content: center;
    color: ${Color['neutral.white']};
    background-color: ${Color['brand.tertiary.dark']};
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    padding: 4px 8px;
    width: fit-content;
    height: 25px;
    justify-content: center;
  }

  .table-content {
    color: ${Color['neutral.dark']};
  }

  .content-value {
    color: ${Color['neutral.darkest']};
  }

  .main-container {
    margin-top: 16px;
  }

  .main-title {
    color: ${Color['brand.tertiary.dark']};
    margin-bottom: 8px;
  }

  .investment-container {
    padding: 16px;
    position: relative;
    margin-top: 8px;
  }

  .investment-sidebar {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 4px;
    border-radius: 8px 0 0 8px;
    background: ${lineColor};
  }

  .details-row {
    margin-bottom: 2px;
  }

  .label-details-row {
    color: ${Color['neutral.dark']};
  }

  .value-details-row {
    text-align: right;
    color: ${Color['neutral.black']};
  }

  .applied-row {
    background: rgba(232, 234, 250, 0.3);
    padding: 8px;
    margin-top: 8px;
  }

  .applied-label {
    color: ${Color['neutral.dark']};
  }

  .amount-value {
    color: ${Color['brand.tertiary.dark']};
  }

  .text-align-right {
    text-align: right;
  }
</style>
`;
};
